import $ from 'jquery';
import '~/app/assets/javascripts/forked_libs/select2';

$(() => {
  const $courseSelect = $('.js-course-select');
  const $filterInput = $('.js-courses-filter-input');
  const $filterForm = $('.js-courses-filter-form');

  function showLoader() {
    $('.js-courses-loader').show();
  }

  function submitForm() {
    showLoader();
    $filterForm.submit();
  }

  function clearCourseSelect() {
    $('.js-course-select').val('');
  }

  $courseSelect.select2({
    theme: 'special-course-l',
    placeholder: 'O que você quer estudar?',
    allowClear: true,
  });

  $courseSelect.on('select2:select', () => {
    submitForm();
  });

  $courseSelect.on('select2:unselecting', () => {
    clearCourseSelect();
    submitForm();
  });

  $filterInput.on('click', () => {
    submitForm();
  });

  $('.js-apply-filters-xs').on('click', () => {
    submitForm();
  });

  $('.js-remove-filter').on('click', (evt) => {
    const filterName = $(evt.currentTarget).attr('data-filter-name');
    const filterValue = $(evt.currentTarget).attr('data-filter-value');

    if (filterName === 'course') {
      // remove value from select2 when remove course filter
      $courseSelect.val('');
    } else if (filterName === 'level') {
      // reset to default value when remove level filter
      $('.js-courses-filter-input[value="Graduação"').attr('checked', true);
    } else {
      // uncheck removed filter
      const selector = `.js-courses-filter-input[value="${filterValue}"]`;
      $(selector).attr('checked', false);
    }

    $(evt.currentTarget).closest('.js-filter-badge').remove();
    submitForm();
  });
});
